import { makeStyles } from "src/makeStyles";

const useStyles = makeStyles()(() => ({
  root: {
    display: "contents"
  }
}));

export default useStyles;
